module.exports = __webpack_public_path__ + "static/media/index-ad-img6.90ab48c4.jpg";